import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { BulkValidationSummarySchema, makeValidatedRowSchema } from '../../shared/bulk-validation.schema';
import { InitializeProcessInputSchema } from '../initialize-add-processes/initialize-add-processes.schema';
/**
 * Validated Process Row Schema
 * Echoes the input row plus resolved ids.
 */ export const ValidatedProcessRowSchema = makeValidatedRowSchema(InitializeProcessInputSchema.extend({
    departmentId: z.string().optional(),
    ownerId: z.string().optional(),
    accountableId: z.string().optional(),
    /** Set when a same-name process already exists in the department (row will be skipped) */ existingProcessId: z.string().optional()
}));
/**
 * Initialize Validate Processes Request Schema
 * POST /api/v2/initialize/processes/validate — dry-run twin of the commit
 * endpoint's create path (updates/removals are commit-only), no writes.
 */ export const InitializeValidateProcessesRequestSchema = z.object({
    processes: z.array(InitializeProcessInputSchema)
});
export const InitializeValidateProcessesResponseSchema = BulkValidationSummarySchema.extend({
    processes: z.array(ValidatedProcessRowSchema)
});
export const InitializeValidateProcessesErrorSchema = BaseErrorSchema;

//# sourceMappingURL=initialize-validate-processes.schema.js.map